import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {RESOURCES as reportsResources} from '../fuseInventoryOrdersResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import FuseTheme from '../global/theme';
import {commonStyles} from '../shared/styles';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    tableHeaderTitle: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.accent2Color,
        color: FuseTheme.palette.textColor,
        fontWeight: '400',
        margin: 0,
        padding: '0.25em 0.5em'
    },
    btnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 10
    }
};

class DialogInventoryOrderResetOverrides extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            loading: false,
            message: null
        };

        this.submitOrderData = this.submitOrderData.bind(this);
    }

    submitOrderData = () => {
        this.setState({
            loading: true,
            message: 'Resetting overrides...'
        });

        let params = {
            job_id: this.props.jobId,
            location_id: this.props.locationId
        };

        let resource = reportsResources.OrderLocationResetOverrides.GET_ONE(params);

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data) {
                this.processSubmission(result.data);
            }
        }).catch((error) => {
            let message = 'Sorry, there was an error resetting this Location Order\'s overridden values.';
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                }
            } else if (error.request) {
                // No response
            } else {
                console.log('Inventory Order Detail Error: ', error.message);
            }
            this.setState({
                error: true,
                message: message,
                loading: false
            });
        });
    };

    processSubmission = (response) => {
        let error = false;
        let message = '';
        if (response.message && response.message.includes('success')) {
            message = 'All Quantity Overrides have been reset. Refreshing...';
        } else if (response.error) {
            error = true;
            message = 'Sorry, there was an error resetting this Location Order\'s overridden values.';
        }

        this.setState({
            error: error,
            loading: false,
            message: message
        }, () => {
            setTimeout(() => {
                if (typeof this.props.onSuccess === 'function') {
                    this.props.onSuccess(error);
                }
            }, 600);
        });
    };

    handleCancel = () => {
        if (typeof this.props.onCancel === 'function') {
            this.props.onCancel();
        }
    };

    render() {
        const {
            locationId
        } = this.props;

        const {
            loading,
            message
        } = this.state;

        return (
            <div className="dialog-content-container">
                <div className="reports-table-title" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        Reset overrides for {(locationId) ? 'Location ' + locationId : 'this Location'}
                    </h3>
                </div>
                {message &&
                    <p>
                        {message}
                    </p>
                }
                {!loading && !message &&
                    <Fragment>
                        <p>
                            Are you sure you want to reset all overrides
                            for {(locationId) ? 'Location ' + locationId : 'this Location'}?
                        </p>
                        <p>
                            This will remove all edited quantities and reset each product to its original requested
                            amount.
                        </p>
                    </Fragment>
                }

                <div style={styles.btnContainer}>
                    <RaisedButton
                        primary
                        type="button"
                        label="Reset Case Qty Overrides"
                        onClick={this.submitOrderData}
                        style={commonStyles.buttonInlineRight}
                        disabled={!!(loading)}
                    />
                    <RaisedButton
                        type="button"
                        label="Cancel"
                        onClick={this.handleCancel}
                        style={commonStyles.buttonInlineRight}
                    />
                </div>
            </div>
        );
    }
}

DialogInventoryOrderResetOverrides.propTypes = {
    jobId: PropTypes.string,
    locationId: PropTypes.string,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func
};

export default DialogInventoryOrderResetOverrides;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogInventoryOrderResetOverrides.js